module.exports = __webpack_public_path__ + "static/media/26UNRWA24.05b6d24d.jpg";